import { AutocompleteClearOnBlurDirective } from './autocompleteClearOnBlur/autocompleteClearOnBlur';
import { AutoFitVirtualRepeatDirective } from './autofitVirtualRepeat/autoFitVirtualRepeat';
import { ChipsAddOnBlurDirective } from './chipsAddOnBlur/chipsAddOnBlur';
import { ChipsClearOnBlurDirective } from './chipsClearOnBlur/chipsClearOnBlur';
import { ChipsDisableDeleteKeyDirective } from './chipsDisableDeleteKey/chipsDisableDeleteKey';
import { ContentEditableDirective } from './contentEditable/contentEditable';
import { DebounceImageDirective } from './debounceImage/debounceImage';
import { LongClickDirective } from './onLongClick/onLongClick';
import { RightClickDirective } from './ngRightClick/ngRightClick';
import { ControlClickDirective } from './onControlClick/onControlClick';
import { FeatureToggleDirective } from './featureToggle/featureToggle';
import { DisplayMessageDirective } from './displayMessage/displayMessage.component';
import { TextViewerDirective } from './textViewer/textViewer';
import { DocViewerDirective } from './documentViewer/documentViewer';

export const componentsModule = angular
	.module('phoenix.components', [
		'phoenix.services'
	])
	.directive('pxAutocompleteClearOnBlur', AutocompleteClearOnBlurDirective)
	.directive('pxAutoFitVirtualRepeat', AutoFitVirtualRepeatDirective)
	.directive('pxChipsAddOnBlur', ChipsAddOnBlurDirective)
	.directive('pxChipsClearOnBlur', ChipsClearOnBlurDirective)
	.directive('pxChipsDisableDeleteKey', ChipsDisableDeleteKeyDirective)
	.directive('pxContenteditable', ContentEditableDirective)
	.directive('pxDebounceImage', DebounceImageDirective)
	.directive('pxOnLongClick', LongClickDirective)
	.directive('ngRightClick', RightClickDirective)
	.directive('pxFeatureToggle', FeatureToggleDirective)
	.directive('pxOnControlClick', ControlClickDirective)
	.directive('pxTextViewer', TextViewerDirective)
	.directive('pxDisplayMessage', DisplayMessageDirective)
	.directive('pxDocumentViewer', DocViewerDirective);


// WEBPACK FOOTER //
// ./src/phoenix/components/index.ts